<ng-container
  *ngIf="{
    product: product$ | async,
    currentImage: currentImage$ | async,
    images: images$ | async,
    currentVideo: currentVideo$ | async,
    videos: videos$ | async,
    tab: currentTab$ | async,
  } as config"
>
  <div class="container-product-media-modal">
    <div class="display-media">
      @if (displayIsLoad) {
        <local-loader></local-loader>
      }

      @if (config.tab === TAB_GALLERY.PHOTO) {
        <div *limitUp="DEVICE_SIZE.DESKTOP" [ngClass]="{ 'd-none': displayIsLoad }">
          <lib-ngx-image-zoom
            [zoomMode]="'hover'"
            (imagesLoaded)="zoomImageListner($event)"
            [fullImage]="config.currentImage?.['superZoom']?.src || config.currentImage?.['zoom']?.src || ''"
            [thumbImage]="config.currentImage?.['zoom']?.src!"
          >
          </lib-ngx-image-zoom>
        </div>

        <ng-container *smallerThan="DEVICE_SIZE.DESKTOP">
          <cx-media [media]="config.currentImage?.zoom!" />
        </ng-container>
      }

      @if (config.tab === TAB_GALLERY.VIDEO) {
        <div class="container-video" [ngClass]="{ 'd-none': displayIsLoad }">
          <iframe
            id="videoIframe"
            [src]="config?.currentVideo?.src || '' | iframeURL | bypassSecurityTrustResourceUrl"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
      }
    </div>

    <div class="tab-container">
      <div class="tabs">
        <div class="tab" [ngClass]="{ active: config.tab === TAB_GALLERY.PHOTO }" role="none" (click)="setTab(TAB_GALLERY.PHOTO)">
          Fotos
        </div>

        @if (config.videos?.length) {
          <div class="tab" [ngClass]="{ active: config.tab === TAB_GALLERY.VIDEO }" role="none" (click)="setTab(TAB_GALLERY.VIDEO)">
            Video
          </div>
        }
      </div>

      <div class="content">
        <ng-container *ngIf="config.tab === TAB_GALLERY.PHOTO">
          <ul class="thumbs" *limitUp="DEVICE_SIZE.DESKTOP">
            <li *ngFor="let image of config.images">
              <div
                role="none"
                (click)="setCurrentImage(image)"
                class="thumb"
                [ngClass]="{ 'is-active': config?.currentImage?.['thumbnail']?.src === image?.['thumbnail']?.src }"
              >
                <cx-media [media]="image.thumbnail" />
              </div>
            </li>
          </ul>

          <div class="thumbs" *smallerThan="DEVICE_SIZE.DESKTOP">
            <p-carousel
              [value]="config.images || []"
              [numVisible]="4"
              [numScroll]="1"
              [circular]="false"
              [autoplayInterval]="false"
              [showNavigators]="config.images && config.images.length > 4"
              [classList]="'custom-carousel floating-indicator'"
            >
              <ng-template pTemplate="image" let-image>
                <div
                  role="none"
                  (click)="setCurrentImage(image)"
                  class="thumb"
                  [ngClass]="{ 'is-active': config?.currentImage?.['thumbnail']?.src === image?.['thumbnail']?.src }"
                >
                  <cx-media [media]="image.thumbnail" />
                </div>
              </ng-template>

              <ng-template pTemplate="previousicon" let-image>
                <span class="material-symbols-outlined text-primary"> arrow_back_ios </span>
              </ng-template>

              <ng-template pTemplate="nexticon" let-image>
                <span class="material-symbols-outlined text-primary m-l-12"> arrow_forward_ios </span>
              </ng-template>
            </p-carousel>
          </div>
        </ng-container>

        <ng-container *ngIf="config.tab === TAB_GALLERY.VIDEO">
          <ul class="thumbs" *limitUp="DEVICE_SIZE.DESKTOP">
            <li *ngFor="let video of config.videos">
              <div
                role="none"
                (click)="setCurrentVideo(video)"
                class="thumb video"
                [ngClass]="{ 'is-active': config?.currentVideo?.src === video?.src }"
                [ngStyle]="{ 'background-image': 'url(' + getThumbVideo(video) + ')' }"
              >
                <span class="material-symbols-outlined"> play_circle </span>
              </div>
            </li>
          </ul>

          <div class="thumbs" *smallerThan="DEVICE_SIZE.DESKTOP">
            <p-carousel
              [value]="config.videos || []"
              [numVisible]="4"
              [numScroll]="1"
              [circular]="false"
              [autoplayInterval]="false"
              [showNavigators]="config.videos && config.videos.length > 4"
              [classList]="'custom-carousel floating-indicator'"
            >
              <ng-template pTemplate="video" let-video>
                <div
                  role="none"
                  (click)="setCurrentVideo(video)"
                  class="thumb video"
                  [ngClass]="{ 'is-active': config?.currentVideo?.src === video?.src }"
                  [ngStyle]="{ 'background-image': 'url(' + getThumbVideo(video) + ')' }"
                >
                  <span class="material-symbols-outlined"> play_circle </span>
                </div>
              </ng-template>

              <ng-template pTemplate="previousicon" let-video>
                <span class="material-symbols-outlined text-primary"> arrow_back_ios </span>
              </ng-template>

              <ng-template pTemplate="nexticon" let-video>
                <span class="material-symbols-outlined text-primary m-l-12"> arrow_forward_ios </span>
              </ng-template>
            </p-carousel>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
